<script>
export default {
    name: "SpinLoader",
    props: {
        size: {
            type: Number,
            default: 18
        },
        color: {
            type: String,
            default: '#fff'
        },
        bgColor: {
            type: String,
            default: 'transparent'
        },
        thickness: {
            type: Number,
            default: 2
        }
    }
}
</script>

<template>
    <span class="loader" :style="{ width: size + 'px', height: size + 'px', border: `${thickness}px solid ${bgColor}`, borderBottomColor: color }"></span>
</template>

<style scoped>
.loader {
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>